import { render, staticRenderFns } from "./ArtistAlbums.vue?vue&type=template&id=03f4608e&"
import script from "./ArtistAlbums.vue?vue&type=script&lang=js&"
export * from "./ArtistAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports